// eslint-disable-next-line camelcase
export const en = {
  publishActions: {
    commitPublication: {
      error: `This story is expired. You may cancel the expiration time to publish this story.`,
      websiteURLsGenerationFailure: `Could not create website URL(s).`,
      noPrimaryWebsite: `A primary website is required to publish. Set a primary website on the Planning tab.`,
      noSubPublishPerm: `User does not have permission to subsequently publish this story.`,
      noInitPublishPerm: `User does not have permission to initially publish this story.`,
      invalidParentRevisionId:
        'Could not publish the story due to an incorrect parent revision ID.<br />Provided: {providedParentRevisionId}<br />Expected: {expectedParentRevisionId}',
    },
    commitPublicationSuccess: {
      published: `Story successfully published.`,
      scheduled: `Story successfully scheduled.`,
    },
    panel: {
      clonedFrom: 'This story was cloned from ',
      clonedTo: 'This story was cloned to create',
      expirationDate: 'Story will expire',
      lastPublishedLocal: 'Last published',
      publishButton: 'Publish',
      scheduledPublishDate: 'Scheduled publish date',
      scheduledPublishRecentSave:
        'The most recently saved version of this story will be published on',
      scheduledPublishStatusError:
        'Error retrieving the latest scheduled publish time. Please try again later.',
      unpublish: 'Unpublish',
      unschedule: 'Unschedule',
      updateButton: 'Update',
    },
    publishField: {
      error: `Enter publish time of now or later.`,
      errorGreater: 'Enter publish time prior to scheduled expiration date.',
    },
    publishImages: {
      error: `The images were not able to be published. Please try to publish the images directly in Photo Center.`,
      success: `{imgCnt, plural, =0 {No images were} =1 {The image was} other {# images were}} published successfully.`,
    },
    publishModal: {
      blurbReact: 'Default time zone: {timezone}',
      systemTimezone:
        'Dates are shown in your system timezone: {systemTimezone}',
      orgTimezone:
        "Dates are shown in your organization's configured timezone: {orgTimezone}. Your system timezone is: {systemTimezone}.",
      blurb:
        'Set the publish time and display time (optional) to be in {timezone} time, which is the time zone {appName} is currently set to.',
      boltNow: 'Now',
      boltCurrent: 'Current display time',
      boltPlanned: 'Planned ready time',
      boltExisting: 'Existing display time',
      buttonCancel: 'Cancel',
      buttonPublish: 'Publish',
      buttonSchedule: 'Schedule',
      buttonUnschedule: 'Unschedule',
      buttonUpdate: 'Update',
      displayTime: 'Display time',
      displayTimeTitle: 'Enter a last-updated time to show to readers.',
      hideDisplayTime: 'Hide display time',
      matchDisplayTime: 'Match display time to publish time',
      planned: 'Planned',
      publish: 'Publish story',
      publishTime: 'Publish time',
      publishTimeTile: 'Enter publish time of now or later.',
      publishTimeTooltip: 'Enter publish time of now or later.',
      showDisplayTime: 'Show display time',
      update: 'Update story',
    },
    toast: {
      unpublishSuccess: 'The story was successfully unpublished!',
      unpublishError: 'An error occurred unpublishing the story.',
      publishInThePast: 'Publish time must be now or in the future.',
    },
    unpublishModal: {
      unpublishTimeLabel: 'Unpublish time',
      cancelButton: 'Cancel',
      unpublishButton: 'Unpublish',
      scheduleUnpublishButton: 'Schedule unpublish',
      unpublishStory: 'Unpublish story',
      error:
        'The unpublish time must be after the published or scheduled publish time.',
    },
    unscheduleExpirationDate: {
      success: `The story expiration date was successfully cancelled.`,
    },
    unscheduleExpirationModal: {
      blurb:
        'Unscheduling the unpublish (expiration) date will cancel the unpublish.',
      cancelButton: 'Cancel',
      cancelExpirationButton: 'Unschedule',
      title: 'Unschedule expiration',
    },
    unscheduleModal: {
      blurb:
        'Unscheduling the publish date will also remove the scheduled unpublish (expiration) date.',
      cancelButton: 'Cancel',
      unschedule: 'Unschedule story',
      unscheduleButton: 'Unschedule',
    },
    schedulePublish: {
      error: 'Scheduling service is down.',
    },
    unschedulePublish: {
      error: `There was a problem unscheduling this story.`,
    },
    validation: {
      websiteMissing:
        'A website is required to publish. Set a website on the {tabName} tab.',
      primaryWebsiteMissing:
        'A primary website is required to publish. Set a primary website on the {tabName} tab.',
      unauthorizedSubsequentPublish:
        'This account is not authorized to subsequently publish this story that is owned by {canonicalWebsite}.',
      unauthorizedInitialPublish:
        'This account is not authorized to initially publish this story that is owned by {canonicalWebsite}.',
      unsaved: 'Please save the story.',
      requiredFieldMissing:
        'Needs {field} in order to publish. Set {field} on the {tabName} tab.',
      requiredSaveFieldMissing: 'Needs {field} in order to save and publish.',
      sectionMissing:
        'A section is required to publish. Set a section on the Planning tab.',
      headlineMissing:
        'A headline is required to publish. Set the headline on the Compose tab.',
    },
  },
}
